import { all, takeEvery, put, call } from 'redux-saga/effects';
import Api from 'src/helpers/api';
import { sendRequest } from 'src/helpers/saga';
import { logger } from 'src/helpers/logger';
import notifications from 'src/redux/notifications/actions';
import { t } from 'src/i18n';
import { JOB_TYPES_ENDPOINT } from './constants';
import { LoadDataRequestAction } from './actions.d';
import actions from './actions';
import actionTypes from './actionTypes';
import type { IApiResponse, IJobTypesListData } from './types';

function genericErrorNotification() {
  return notifications.addNotification({
    headline: t('dash.common.notification.error_headline'),
    type: 'error',
    message: t('dash.common.notification.something_went_wrong'),
  });
}

const api = new Api(JOB_TYPES_ENDPOINT);

export function* loadDataRequest({
  payload,
}: LoadDataRequestAction): Generator<unknown, void, IApiResponse<IJobTypesListData> | undefined> {
  try {
    const { filter, ...rest } = payload;
    const search = { ...rest, ...(filter ? { filter } : {}) };
    const result = yield call(sendRequest, api.load, { search }, notifications.REQUEST_ERROR);

    if (result?.status === 200 && result.data?.success?.data?.records) {
      const { records, totalCount, filteredCount, sortableColumns = [], filters = [] } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          records,
          total: totalCount,
          filteredTotal: filteredCount,
          filters,
          sortableColumns,
        }),
      );

      return;
    }

    yield put(actions.loadDataError());

    // `sendRequest` returns nothing when it reported the failure itself; anything else it kept quiet.
    if (result) {
      yield put(genericErrorNotification());
    }
  } catch (error) {
    logger.error(error);
    yield put(actions.loadDataError());
    yield put(genericErrorNotification());
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actionTypes.LOAD_DATA_REQUEST, loadDataRequest)]);
}
